import { styled } from '@mui/material';

export const UnderlinedLink = styled('a')(() => ({
    color: 'black',
    marginLeft: '2px',
    textDecoration: 'underline',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: 0,
    verticalAlign: 'middle',
    textDecorationStyle: 'solid',
    textDecorationOffset: 0,
    textDecorationThickness: 0,
    textDecorationSkipInk: 'auto',
    '&:hover': {
        cursor: 'pointer'
    }
}));
